module.exports = __webpack_public_path__ + "static/media/46.e1930123.svg";